import React from 'react';
import { Hammer, Sparkles } from 'lucide-react';

export const ProductionNowCard = ({ shelf = 'this shelf', testId = 'books-in-production-card' }) => (
  <div
    className="flex aspect-[11/17] w-40 shrink-0 flex-col justify-between rounded-md border border-dashed border-primary/45 bg-primary/5 p-5 text-left"
    data-testid={testId}
    role="status"
  >
    <div className="flex items-center justify-between text-primary"><Hammer className="h-5 w-5" /><Sparkles className="h-4 w-4" /></div>
    <div>
      <div className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground">Shelf update</div>
      <div className="mt-2 text-base font-semibold leading-tight">These Books In Production Now</div>
      <p className="mt-3 text-[11px] leading-5 text-muted-foreground">Real titles curated for {shelf} will appear here as their authors publish them.</p>
    </div>
  </div>
);

export default ProductionNowCard;